module.exports = __webpack_public_path__ + "img/task388.512b9914.png";